
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayAcuatorGeneralClosed as ObiTwowayAcuatorGeneralClosedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-acuator-general-closed.js';
 
 
 

 
 export const ObiTwowayAcuatorGeneralClosed = createComponent({
   react: React,
   tagName: 'obi-twoway-acuator-general-closed',
   elementClass: ObiTwowayAcuatorGeneralClosedElement,
   events: {
     
   }
  });
 
 